import useValidator from '../../../../utils/hooks/useValidator'
import { invalidNumberInput, isEmpty } from '../../../../utils'
import { useSelector } from 'react-redux'
import { getConversionTrackingError } from '../campaignValidation'

const useCampaignValidator = () => {
  const {
    campaignType,
    bizChannelId,
    name,
    conversionTrackingId,
    dailyBudgetYn,
    dailyBudgetAmount,
  } = useSelector(state => state.ad.campaign.form)
  const { errors, validate, addError, clearError } = useValidator(
    () => ({
      bizChannelId: bizChannelId === null && '비즈채널을 선택해주세요.',
      name: isEmpty(name) && '캠페인 이름을 입력하세요.',
      conversionTrackingId: getConversionTrackingError(
        campaignType,
        conversionTrackingId
      ),
      dailyBudgetAmount:
        dailyBudgetYn === 'Y' &&
        (dailyBudgetAmount === '' ||
          invalidNumberInput(dailyBudgetAmount, 10000000, 1000, 10)) &&
        '일예산은 최소 1,000원 ~ 최대 1천만원까지 10원 단위로 설정해주세요.',
    }),
    [
      campaignType,
      bizChannelId,
      name,
      conversionTrackingId,
      dailyBudgetYn,
      dailyBudgetAmount,
    ]
  )
  return {
    errors,
    validate,
    addError,
    clearError,
  }
}
export default useCampaignValidator
